export const statsData = [
  { label: "Years of Innovation", value: "10+" },
  { label: "Projects Delivered", value: "500+" },
  { label: "Industry Partners", value: "50+" },
  { label: "Safety Standards", value: "100%" },
];

export const partnersData = [
  "RIL",
  "IOCL",
  "ONGC",
  "BPCL",
  "HPCL",
  "ESSAR",
  "MCGM",
  "PMC",
  "PCMC",
  "ADNOC",
  "NIOC",
  "BASF",
];

export const solutionsData = [
  {
    title: "Mobile & Tablets",
    desc: "Enhancing safety with real-time communication while digitizing paperwork to streamline maintenance workflows.",
    icon: "ion:tablet-portrait-outline",
    link: "/products/mobile",
    isHighlight: false,
  },
  {
    title: "Gas Detectors",
    desc: "A comprehensive range of gas detection products for industrial facilities & hazardous areas.",
    icon: "ion:speedometer-outline",
    link: "/products/gas-detector",
    isHighlight: false,
  },
  {
    title: "Radios (DMR/PoC)",
    desc: "Keeping every personnel connected even in tough conditions. Featuring the new CD765 & CD775 Series.",
    icon: "ion:radio-outline",
    link: "/products/wireless",
    isHighlight: false,
  },
  {
    title: "New Launches",
    desc: "Explore our latest innovations, featuring next-generation industrial gadgets.",
    icon: "ion:sparkles-outline",
    link: "/products/water-logger",
    isHighlight: true,
  },
];

export const valuesData = [
  {
    title: "Our Vision",
    desc: "To create innovative solutions & be a leader in integrated communication for the connected world.",
    icon: "ion:eye-outline",
  },
  {
    title: "Our Mission",
    desc: "We are committed to leading the IS industry by bringing fresh perspectives in design and engineering.",
    icon: "ion:rocket-outline",
  },
  {
    title: "Our Values",
    desc: "Transparency | Diverse Perspectives | Respect. We believe in valuing people, and in turn, people valuing our mission.",
    icon: "ion:heart-outline",
  },
];

export const sectorsData = [
  {
    title: "IoT & IIoT Services",
    desc: "ATEX-certified smartphones and feature phones designed for hazardous environments.",
    icon: "ion:wifi-outline",
    link: "/products/mobile",
  },
  {
    title: "Wireless Communication",
    desc: "Advanced digital radios and communication systems for mission-critical operations.",
    icon: "ion:radio-sharp",
    link: "/products/wireless",
  },
  {
    title: "Gas Detection",
    desc: "Portable and reliable gas detection solutions for Zone 0, 1, 20 and 21 environments.",
    icon: "ion:construct-outline",
    link: "/products/gas-detector",
  },
  {
    title: "Water and Gas Pipeline Network Management.",
    desc: "Real-time water network monitoring and resource optimization solutions.",
    icon: "ion:water-outline",
    link: "/products/water-logger",
  },
];
